import { clear, unprefix } from '../../../helpers/compact';
import { toText } from '../fields/text';
import { author } from './author';

export const caption = (data) => {
  const { txt, ...rest } = unprefix('caption', data);
  if (txt) {
    return clear({
      text: toText(txt),
      author: author(rest),
    });
  }
};
